// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__AlYZM","l3":"styles_l3__3elFO"};